import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from '../Pages/Home';
import Success from '../Pages/Success';		
import Fail from '../Pages/Fail';
const Router = () => {
	return (
		<div>
			<BrowserRouter>
				<Routes>
					<Route index element={<Home />} />
					<Route path="/success" element={<Success />} />
					<Route path="/failed" element={<Fail />} />
				</Routes>
			</BrowserRouter>
		</div>
	)
}

export default Router;